export enum VehicleTypeEnum{
    OWN = 'OWN',
    RENT = 'RENT'
}